module.exports = __webpack_public_path__ + "img/list-img0.dcd64464.png";